import PDFDocViewer from "components/PDF/PDFDocViewer";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import closeIcon from "Assets/images/colse-pdf.png";
import PdfUrlView from "./PdfUrlView";
import CommonButton from "./CommonButton";

const DocViewModal = ({ show, setShow, doc, onAccept, values }) => {
    const handleClose = () => setShow(false);
    console.log("selectedPolicy", doc);

    return (
        <Modal
            className="pdf-viewer-class"
            fullscreen
            show={show}
            onHide={handleClose}
        >
            <Modal.Header className="border-0 d-flex justify-content-end align-items-center gap-3">
                {/* {!values?.policies?.some(
                    (p) => p?.policy_id === doc?.id && p?.is_accepted
                ) && (
                        <CommonButton
                            text="Accept Policy"
                            className="button-filled"
                            onClick={onAccept}
                        />
                    )} */}



                <img
                    src={closeIcon}
                    alt="close"
                    width={20}
                    height={20}
                    style={{ cursor: "pointer" }}
                    onClick={handleClose}
                />
            </Modal.Header>

            {doc && (
                <iframe
                    key={doc?.url}
                    src={doc?.url}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                />
            )}


        </Modal>
    );
};

export default DocViewModal;
